/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./HousekeepingContent2.css";

/* ==== IMAGES (use real icons here) ==== */
import IconTrusted from "../../Image/HouseKeeping/Housekeeping1.png";
import IconCoverage from "../../Image/HouseKeeping/Housekeeping1.png";
import IconCompliance from "../../Image/HouseKeeping/Housekeeping1.png";


const EventCleaningContent = () => {
  return (
    <div>
    <section className="hk2-wrapper">

      {/* TAG */}
      <div className="hk2-tag">About This Service</div>

      {/* TITLE */}
      <h2 className="hk2-title">Event Cleaning</h2>
      <div className="hk2-underline"></div>

      {/* CONTENT BOX */}
      <div className="hk2-box">
        <p>
         On-demand teams for corporate events, exhibitions, meetings and conferences. Our quick-response cleaning teams support corporate events, exhibitions, meetings and conferences with pre-setup cleaning, live support and after-event restoration.
        </p>

        <p>
        We ensure your event space remains pristine throughout, allowing you to focus on your event's success while we handle all cleaning requirements seamlessly and efficiently.
        </p>

        <p>
        From small board meetings to large conferences and exhibitions, we provide professional cleaning support that maintains your event's professionalism and attendee comfort.
        </p>
      </div>

      {/* ICON 3 CARDS (IMAGE LEFT, TEXT RIGHT) */}
      <div className="hk2-icons">

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconTrusted} className="hk2-icon-img" alt="Trusted Service" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Trusted Service</h4>
            <p>Since 2019</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCoverage} className="hk2-icon-img" alt="Coverage" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Coverage</h4>
            <p>15 Cities</p>
          </div>
        </div>

        <div className="hk2-card">
          <div className="hk2-left">
            <div className="hk2-icon-wrap">
              <img src={IconCompliance} className="hk2-icon-img" alt="Compliance" />
            </div>
          </div>
          <div className="hk2-right">
            <h4>Compliance</h4>
            <p>100% Certified</p>
          </div>
        </div>

      </div>

    </section>
   
    </div>
  );
};

export default EventCleaningContent;
